import { academyDomain } from "./domain";
import { Auth } from "./domain_v2/auth";
import { ROUTE_NAME } from "./RouteName";

/**
 * 앱 시작 시 인증 상태를 확인하고 적절한 페이지로 리다이렉트
 * - 이미 올바른 페이지에 있으면 리다이렉트하지 않음 (무한루프 방지)
 */
export const authDaemon = async () => {
  const currentPath = window.location.pathname;

  try {
    // 1. 토큰 확인 및 마이그레이션
    let isAuth = Auth.authService.isTokenValid;

    if (!isAuth && Auth.authService.tokenInfo?.refreshToken) {
      try {
        await Auth.authService.reissue();
        isAuth = Auth.authService.isTokenValid;
      } catch (error) {
        const message =
          error instanceof Error ? error.message : "unknown reissue error";
        console.error("Token reissue failed in authDaemon:", message);
        Auth.authService.clearToken();
      }
    }

    if (!isAuth) {
      // 레거시 토큰 마이그레이션 시도
      const migratedToken = await Auth.authService.migrateLegacyToken();
      isAuth = !!migratedToken;
    }

    // 2. 인증되지 않은 경우
    if (!isAuth) {
      // 이미 로그인 페이지에 있으면 리다이렉트하지 않음
      if (currentPath !== ROUTE_NAME.LOGIN && currentPath !== ROUTE_NAME.ROOT) {
        window.location.pathname = ROUTE_NAME.LOGIN;
      }
      return;
    }

    // 3. 인증된 경우
    // 학원 정보 가져오기
    await academyDomain.fetchAcademyInfo();

    // 로그인 페이지나 루트에 있으면 메인으로 이동
    if (currentPath === ROUTE_NAME.LOGIN || currentPath === ROUTE_NAME.ROOT) {
      window.location.pathname = ROUTE_NAME.MAIN;
    }
    // 이미 보호된 페이지(/main, /student-list 등)에 있으면 그대로 유지
  } catch (error) {
    const message =
      error instanceof Error ? error.message : "unknown auth daemon error";
    console.error("Auth daemon failed:", message);
    Auth.authService.clearToken();

    // 에러 발생 시 로그인 페이지로 (이미 로그인 페이지가 아닌 경우에만)
    if (currentPath !== ROUTE_NAME.LOGIN && currentPath !== ROUTE_NAME.ROOT) {
      window.location.pathname = ROUTE_NAME.LOGIN;
    }
  } finally {
    Auth.authService.setInitializing(false);
  }
};
